import { jsx } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
export const LoadingDots = () => {
  const [dots, setDots] = useState("");
  useEffect(() => {
    const interval = setInterval(() => {
      setDots((dots2) => {
        return dots2.length === 3 ? "" : dots2 + ".";
      });
    }, 500);
    return () => clearInterval(interval);
  }, []);
  return /* @__PURE__ */ jsx("span", { children: dots });
};
